// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"87cedcfb","455":"75f45c52"}[chunkId] + ".chunk.js";
};